
import { useParams } from 'react-router-dom';
import { MedidasFormState } from '../../../context/medidas/MedidasFormState';
import { Form } from './form';

export const MedidasFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Medida":"Crear Medida";
  
  return (
    <MedidasFormState>
        <br />
        <Form title={title} />
    </MedidasFormState>
  );
};
